import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { apiPaths } from '../../../../../service/apiPaths';
import ApiService from '../../../../../service/ApiService';
import { IAddDocument, IDocument } from '../../Document.props';

const useEditDocument = (documentId: string, setMethod: () => void) => {
  const [documentData, setDocumentData] = useState<any>({
    title: "",
    link: "",
    video: "",
  });
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getDocument}/${documentId}`,
      });
      populateFormData(response);
    } catch (error) {
      toast.error(`Error - ${error}`, { duration: 5000 });
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const populateFormData = (data: IDocument) => {
    setDocumentData({
      title: data?.title,
      link: data?.link,
      tag: data?.tag,
      video: data?.video,
    });
  };

  const handleInputChange = (field: keyof IAddDocument, value: any) => {
    setDocumentData((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (
    field: "pdfFile" | "videoFile",
    file: File | null
  ) => {
    setDocumentData((prev: any) => ({ ...prev, [field]: file }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("title", documentData.title);
      formData.append("link", documentData.link);
      formData.append("tag", documentData.tag);
      formData.append("video", documentData.video || '');
      const response = await ApiService({
        method: "PATCH",
        endpoint: `${apiPaths.updateDocument}${documentId}`,
        data: formData,
      });
      if (response !== "undefined") {
        toast.success("Document update successfully", {
          duration: 5000,
        });
      }
    } catch (error) {
      toast.error(`Error - ${error}`, {
        duration: 5000,
      });
      console.error("Error update document:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    documentData,
    handleInputChange,
    handleFileChange,
    handleSave,
  };
};

export default useEditDocument;
